export default __webpack_public_path__ + "static/media/replace.497c2fe6.svg";